<template xmlns="http://www.w3.org/1999/html">
  <SOSlotModal
      modal-title="Input Manual"
      :modal-id="id"
      @close="close"
  >
    <template v-slot:modal-body>
      <SOInputRegular
          title="ID Device"
          :required="true"
          placeholder="Masukkan ID Device"
          v-model="input"
          @input="inputEmit(input)"
      />
    </template>
    <template v-slot:modal-footer>
      <SOButton
          :primary="true"
          :full="true"
          text="Lanjut"
          @action="$emit('action')"
      />
    </template>
  </SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
export default {
  name: "SOModalInputManual",
  components: {SOInputRegular, SOButton, SOSlotModal},
  data() {
    return {
      id: 'modal-manual-input',
      input: ""
    }
  },
  methods:{
    close() {
      $("#" + this.id).modal("hide");
      setTimeout(() => {
        this.$emit("close")
      }, 500)
    },
    inputEmit(input){
      this.$emit('input', input)
    }
  },
  mounted() {
    $("#"+this.id).modal("show")
  }
}
</script>

<style scoped>

</style>